// GENERATED by npm run generate-graphql-operations
const DeleteSeedFromStation = 'mutation DeleteSeedFromStationWeb($stationId: String!, $seedId: String!) {   removeStationSeed(stationId: $stationId, seedId: $seedId) {     status   } } ';
export default DeleteSeedFromStation;
